import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-email-input',
  templateUrl: './email-input.component.html',
  styleUrls: ['./email-input.component.css']
})
export class EmailInputComponent implements OnInit {

  @Input() loadedEmail;
  @Output() public emailOutputData = new EventEmitter();
  email;
  emailModalData = {
    windowEnabled: true,
    nextStepClicked: false,
    nextStep: '',
    email: {
      value: null,
      isValid: null
    }
  };
  
  constructor() { }

  ngOnInit(): void {
    this.email = new FormControl(this.loadedEmail || '', [Validators.required, Validators.email]);
  }

  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'este campo es obligatorio';
    }
    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  onFilledEmail(event): void {
    if (this.email.valid) {
      // Email is valid
      this.emitChangesInEmailInout();
    }
  }

  setObjectValues() {
    // Update data to emit
    this.emailModalData.nextStepClicked  = true;
    this.emailModalData.nextStep  = '';
    this.emailModalData.windowEnabled = true;
    this.emailModalData.email.value = this.email.value;
    this.emailModalData.email.isValid = this.email.valid;
  }

  // EMITTER
  emitChangesInEmailInout(): void {
    this.setObjectValues();
    // Emit
    this.emailOutputData.emit(this.emailModalData);
  }

}
